import { useContext } from 'react';
import { useEffect, useState } from 'react';
import image from '../assets/edited.png';
import AuthContext from '../store/auth-context';

const AboutMe = () => {
  const context = useContext(AuthContext);
  const [gitLanguages, setGitLanguages] = useState('');
  const languages = ['Node', 'Express', 'Sass', 'React', 'Mongo'];

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });

  useEffect(() => {
    const recent = languages.map((el, index) => {
      return (
        <p className='arrow' key={`${index}-about`}>
          {el}
        </p>
      );
    });
    setGitLanguages(recent);
  }, []);

  return (
    <div
      className={`main-screen__content  ${
        context.pathname === '/about' ? 'show-section' : ''
      }`}
    >
      <div className='main-screen__content-header'>
        <h2>
          <span className='highlight'>&#91;</span>About Me
          <span className='highlight'>&#93;</span>
        </h2>
      </div>
      <img
        src={image}
        alt='Aisha solo'
        className='main-screen__content-image'
      />
      <p className='main-screen__content-main'>
        Hello! My name is Aisha and I build things on the web. My interest in
        web development started in 2008 when marquee was popular, using HTML and
        CSS, I built a site similar to Matrix.
      </p>
      <p className='main-screen__content-main'>
        Fast-forward to today, I&#39;m currently a freelance full-stack
        developer working with various
        <span className='highlight'> start-up companies</span> and
        <span className='highlight'> individuals </span>where projects range
        from a simple modelling portfolio, to booking application, to an
        e-commerce web application.
      </p>
      <p className='main-screen__content-main'>
        Learning is a continous process, hence, I study on a daily basis to
        further hone my skills.
      </p>
      <p className='main-screen__content-main'>
        These are a few technologies I’ve been working with recently:
      </p>
      <div className='d-flex  flex-wrap '>{gitLanguages}</div>
    </div>
  );
};

export default AboutMe;
